module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACySURBVEhL7Y0xDoJAFES3sbCh8k6WdrZWnsELeQJP4AG8EIkuzMpjN+RnBTfERMJLJsDMZ8Yth2YE7/1Vjw3nkS61ECfwP6KRm7TllzdEBuIEvg2ESi+S5+Su14rIwM13AwGVnqUnZw9pRzSgiwsGAho4SrX0kk7YA6gpGwioeC8d+DRQUz4wBjXrQB5qpg9gG4gj2BHsBP7vB3qIs3kPZ+tAHs6WPDAX1CbwZ4Pav8e5Fvn9yFyQSzNDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-floor-plan/light/24.png
// module id = 2050
// module chunks = 2